import { Logger } from "aws-amplify";
const logger = new Logger("Device Config Mixin");

var xml2js = require('xml2js');

export const deviceConfigMixin = {
  methods: {
    valueUpdated(val){
      this.$emit('valueUpdatedEvent', val);
    },
    returnMappedVal(val, items) {
      var maps = [].concat.apply([], items);
      let mapVal = maps.find(item => {
        return item.label === val
      });

      return mapVal ? mapVal.xml : val;
    },
    returnDeviceRuleState(rule) {
      return rule;
    },
    uploadFileFromDisk(file) {
      let xmlParser = new DOMParser();
      let xml = xmlParser.parseFromString(file, "text/xml");
      let serialiser = new XMLSerializer();
      let xmlString = serialiser.serializeToString(xml);
      let res = {};

      const errorCheck = xml.getElementsByTagName('parsererror')
      // Check for any errors in XML
      if(errorCheck.length > 0) {
        throw new Error('Invalid XML');
      }

      xml2js.parseString(xmlString, (err, result) => {
        if (result) {
          logger.info('parsed XML : ', result)
          res = result
        }
      });

      return JSON.parse(JSON.stringify(res));
    },
    /**
     * 
     * @param {Object} o - Object in question to determine if it is a primitive object
     * Used in hasSettingBeenModified
     */
    isPrimitive(o) {
      switch (typeof o) {
        case "object": {
          return false;
        }
        case "function": {
          return false;
        }
        default: {
          return true;
        }
      }
    },
    /**
     * 
     * @param {Object} init - The init config that is created when initially requested from DVR or uploaded via file 
     * @param {Object} current - The config that the user can modify 
     */
    configComparison(previous, current) {
      const typeOf = o => Object.prototype.toString.call(o);
      const isObject = o => o !== null && !Array.isArray(o) && typeOf(o).split(" ")[1].slice(0, -1) === "Object";

      if (this.isPrimitive(previous) && this.isPrimitive(current)) {
        if (previous === current) {
          return "";
        }
    
        return current;
      }
    
      if (isObject(previous) && isObject(current)) {
        const diff = this.configComparison(Object.entries(previous), Object.entries(current));
    
        return diff.reduce((merged, [key, value]) => {
          return {
            ...merged,
            [key]: value
          }
        }, {});
      }
    
      const changes = [];
    
      if (JSON.stringify(previous) === JSON.stringify(current)) {
        return changes;
      }
    
      for (let i = 0; i < current.length; i++) {
        const item = current[i];
    
        if (JSON.stringify(item) !== JSON.stringify(previous[i])) {
          changes.push(item);
        }
      }
    
      return changes;
    }
  }
}